<footer>

  <div class="container-fluid">
    <div class="row">
      <!-- <div class="col-sm">
        <p class="text-muted m-0">
          Sivu generoitu {{ generationDate | date : 'd.M.yyyy H:mm' }}
        </p>
      </div> -->

      <div class="col-auto">
        <p class="m-0 text-xs">
          Copyright &copy; Kupari Solutions Oy 2018-{{generationDate | date:'yyyy'}}
        </p>
      </div>
    </div>
  </div>
</footer>